// Lightweight logger that's silent in production builds.
// Use instead of console.* so we don't ship dev noise to end users.

const isDev = process.env.NODE_ENV !== "production";

export const log = {
  info: (...args) => { if (isDev) console.log(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { /* keep errors even in prod for diagnostics */ console.error(...args); },
};
